export default class BoxLink {

    constructor() {
        this.addEvents();
    }

    addEvents() {

        jQuery(document).ready(function($) {
            $('.box-link').on('click', function (e){
                let link = $(this).find('a').attr('href');
                if(link){
                    if($(this).find('a').attr('target') == "_blank"){
                        window.open(link, '_blank');
                    }else{
                        window.location = link;
                    }
                }
            })

        })
    }

}